import { Card, Space, Tag, Typography } from 'antd';
import { trpc } from '../../lib/api';

const { Title, Text } = Typography;

export function PartnerRequestsPage() {
  const { data, isLoading } = trpc.partnerPortal.listRequests.useQuery({
    page: 1,
    limit: 50,
  });

  const requests = data?.requests ?? [];

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Title level={3} style={{ margin: 0 }}>申請一覧</Title>

      <Card loading={isLoading}>
        {requests.length === 0 ? (
          <Text type="secondary">申請はありません。</Text>
        ) : (
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            {requests.map((request) => (
              <div key={request.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <Text strong>{request.companyName ?? request.companyId}</Text>
                  <div style={{ fontSize: 12, color: '#888' }}>
                    種別: {request.requestType} / 状態: {request.requestStatus}
                  </div>
                </div>
                <Tag>{request.requestStatus}</Tag>
              </div>
            ))}
          </Space>
        )}
      </Card>
    </Space>
  );
}
